import handleDefaultInit from './handleDefaultInit';
import handleFullInit from './handleFullInit';
import handleThumbsInit from './handleThumbsInit';
import handleProductsInit from './handleProductsInit';
import handleContentsliderInit from './handleContentsliderInit';
import handleReferenceInit from './handleReferenceInit';
import handleCompactCardInit from './handleCompactCardInit';
import handleHistorysliderInit from './handleHistorysliderInit';
// import handleThumbsSelection from './handleThumbsSelection';

/**
 * Attach interactions to every element that matches selector.
 */
$('[data-gallery]').each((_, component) => {
    const type = $(component).attr('data-gallery');

    let handleInit = handleDefaultInit;
    if (type === 'full') handleInit = handleFullInit;
    if (type === 'reference') handleInit = handleReferenceInit;
    if (type === 'thumbs') handleInit = handleThumbsInit;
    if (type === 'product') handleInit = handleProductsInit;
    if (type === 'contentslider') handleInit = handleContentsliderInit;
    if (type === 'cardslider') handleInit = handleCompactCardInit;
    if (type === 'history') handleInit = handleHistorysliderInit;
    // if (type === 'thumbs') {
    //     $(component).on('click', 'a', $(component).preventDefault());
    // }
    $(window).on('load', handleInit(component));
});



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/index.js